import React, {Component} from 'react';
import Raven from 'raven-js'
import ErrorBoundaryFallbackComponent from './ErrorBoundaryFallbackComponent';

class ErrorBoundary extends Component {
  static defaultProps = {
    FallbackComponent: ErrorBoundaryFallbackComponent,
  };

  state = {
    error: null,
    info: null,
  };

  componentDidCatch(error, info) {
    const {onError} = this.props;
    Raven.captureException(error, { extra: info });
    console.log('error boundary')
    console.log(error)
    console.log(info)
    
    if (typeof onError === 'function') {
      try {
        onError.call(this, error, info ? info.componentStack : "");
      } catch (ignoredError) {}
    }

    this.setState({error, info});
  }

  render() {
    const {children, FallbackComponent} = this.props;
    const {error, info} = this.state;

    if (error !== null) {
      return (
        <FallbackComponent
          componentStack={info ? info.componentStack : ''}
          error={error}
        />
      );
    }

    return children;
  }
}

export const withErrorBoundary = (Component, FallbackComponent, onError) => props => (
  <ErrorBoundary FallbackComponent={FallbackComponent} onError={onError}>
    <Component {...props} />
  </ErrorBoundary>
)

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/errors/ErrorBoundary.js